import './App.css'
import React from 'react'

let origin = window.location.origin
origin = origin.replace(/:3000/, '')

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      running: false,
      startTime: Date.now(),
      currentTime: Date.now(),
      saving: false
    }
  }

  componentDidMount = () => {
    window.addEventListener('keydown', this.handleKeyPress)
    setInterval(this.updateTime, 10)
  }
  
  componentWillUnmount = () => {
    window.removeEventListener('keydown', this.handleKeyPress)
  }

  render = () => {
    return (
      <div className='app'
        style={{ color: this.state.running ? 'red' : 'green' }}
      >
        <div className='timer'>
          {this.state.saving ? "saving..." : this.displayTime()}
        </div>
      </div>
    )
  }

  handleKeyPress = (e) => {
    if (e.key === ' ') {
      if (this.state.running) {
        this.stopTimer()
      }
      else {
        this.startTimer()
      }
    }
    else if (e.key === 'Backspace') {
      this.resetTimer()
    }
    else if (e.key === 'Enter') {
      this.saveTime()
    }
  }

  startTimer = () => {
    this.setState({ running: true, startTime: Date.now(), currentTime: Date.now() })
  }

  stopTimer = () => {
    this.setState({ running: false })
  }

  resetTimer = () => {
    this.setState({ running: false, startTime: Date.now(), currentTime: Date.now() })
  }

  saveTime = async () => {
    if (this.state.saving) return
    this.setState({ saving: true })
    await fetch(`${origin}/documents/speedrun_timer/save.php?time=${this.displayTime()}`)
    setTimeout(() => { this.setState({ saving: false }) }, 1000)
  }

  updateTime = () => {
    if (!this.state.running) return
    this.setState({ currentTime: Date.now() })
  }

  displayTime = () => {
    const ms = this.state.currentTime - this.state.startTime
    // return new Date(ms).toISOString().slice(11, 19)
    return new Date(ms).toISOString().slice(11, 22)
  }
}

export default App
